<template>
  <div class="Faq">
    <h2 class="Faq__heading">Frequently asked questions</h2>
    <p class="Faq__subtitle">Why FormBeat isn't like the apps you've tried.</p>

    <div class="Faq__grid">
      <div v-for="(col, ci) in columns" :key="ci" class="Faq__col">
        <details v-for="faq in col" :key="faq.title" class="Faq__item">
          <summary class="Faq__summary">
            <span class="Faq__q">{{ faq.title }}</span>
            <svg
              class="Faq__chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </summary>
          <div class="Faq__answer" v-html="faq.content"></div>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
import { homeFaqs } from 'data/homeFaqs'

export default {
  data() {
    return {
      faqs: homeFaqs
    }
  },

  computed: {
    columns() {
      const mid = Math.ceil(this.faqs.length / 2)
      return [this.faqs.slice(0, mid), this.faqs.slice(mid)]
    }
  }
}
</script>

<style lang="postcss" scoped>
.Faq {
  &__heading {
    @apply xl:text-5xl mb-4 text-4xl font-bold leading-tight text-center;
  }

  &__subtitle {
    @apply max-w-2xl mx-auto mb-12 text-lg text-center text-gray-600;
  }

  &__grid {
    @apply md:flex md:gap-x-12 max-w-6xl mx-auto;
  }

  &__col {
    @apply md:flex-1 divide-y divide-gray-200;
  }

  &__summary {
    @apply flex items-start justify-between gap-4 py-4 cursor-pointer select-none;
    list-style: none;
  }

  &__summary::-webkit-details-marker {
    display: none;
  }

  &__summary:focus-visible {
    outline: 2px solid theme('colors.primary');
    outline-offset: 4px;
    border-radius: 4px;
  }

  &__q {
    @apply text-lg font-semibold text-gray-900;
    transition: color 0.15s ease;
  }

  &__summary:hover &__q {
    @apply text-primary;
  }

  &__chevron {
    @apply flex-shrink-0 w-5 h-5 text-gray-400;
    margin-top: 0.2rem;
    transition: transform 0.25s ease;
  }

  &__item[open] &__chevron {
    @apply text-primary;
    transform: rotate(180deg);
  }

  &__answer {
    @apply pb-5 text-lg leading-relaxed text-gray-700;
  }

  &__item[open] &__answer {
    animation: faqReveal 0.25s ease;
  }
}

.Faq__answer ::v-deep a {
  @apply text-primary;
}

.Faq__answer ::v-deep a:hover {
  @apply underline;
}

.Faq__answer ::v-deep ul {
  @apply pl-5 mt-3 mb-1 list-disc;
}

.Faq__answer ::v-deep li {
  @apply mb-2;
}

.Faq__answer ::v-deep strong {
  @apply font-semibold text-gray-900;
}

@keyframes faqReveal {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
